var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import authentication from "@irati/auth";
import { H5 } from "@irati/ui/src/Headings";
import { FormattedMessage } from "@irati/utils/lang";
import Button from "@irati/ui/src/Button";
var ButtonWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 15px;\n"], ["\n  margin-top: 15px;\n"])));
var StyledButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-width: 140px;\n  margin-left: 15px;\n"], ["\n  min-width: 140px;\n  margin-left: 15px;\n"])));
var FlexWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var MessageSent = function (_a) {
    var onNewMessage = _a.onNewMessage, onGoBack = _a.onGoBack;
    var backButtonContentId = authentication.isGlobalAdmin()
        ? "insights.anonChat.messageSent.button.admin"
        : "insights.anonChat.messageSent.button.user";
    return (React.createElement(FlexWrapper, null,
        React.createElement(H5, null,
            React.createElement(FormattedMessage, { id: "insights.anonChat.messageSent.text" })),
        React.createElement(ButtonWrapper, null,
            React.createElement(StyledButton, { onClick: onGoBack },
                React.createElement(FormattedMessage, { id: backButtonContentId })),
            React.createElement(StyledButton, { onClick: onNewMessage, primary: true, spaced: true },
                React.createElement(FormattedMessage, { id: "insights.anonChat.messageSent.addNew" })))));
};
export default MessageSent;
var templateObject_1, templateObject_2, templateObject_3;
